/* SPN Anfrage
   Auf der Ausstattungsseite entsteht das Angebot sofort. Wer die Felder
   ausfuellt und absendet, bekommt sein Angebotsblatt im selben Moment
   zum Sichern oder Drucken. Niemand wartet auf eine Rueckmeldung. */
(function () {
  var ZEILE = 'Das Angebot entsteht sofort. Beim Absenden öffnet es sich zum Sichern als PDF oder zum Ausdrucken. Eine Kopie geht an uns.';
  var LABEL = 'Angebot erstellen';

  function bereit() {
    var form = document.getElementById('spn-anfrage-form');
    if (!form || form.getAttribute('data-spn-anfrage') === 'ja') return;
    form.setAttribute('data-spn-anfrage', 'ja');

    var knopf = form.querySelector('button[type="submit"], input[type="submit"]');

    if (knopf) {
      var alt = (knopf.textContent || '').trim();
      if (alt.indexOf('anfordern') > -1) {
        knopf.textContent = LABEL;
      }
      if (!form.querySelector('.spn-frist')) {
        var p = document.createElement('p');
        p.className = 'spn-frist';
        p.textContent = ZEILE;
        p.style.margin = '12px 0 0';
        p.style.fontSize = '14px';
        p.style.lineHeight = '1.5';
        p.style.opacity = '.75';
        if (knopf.parentNode) {
          knopf.parentNode.insertBefore(p, knopf.nextSibling);
        }
      }
    }

    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-spn-ab') === 'ja') return;
      var druck = document.querySelector('[data-action="print"]');
      if (!druck || druck.disabled) return;
      e.preventDefault();
      form.setAttribute('data-spn-ab', 'ja');
      var los = false;
      function senden() {
        if (los) return;
        los = true;
        try { form.submit(); } catch (err) { }
      }
      try {
        window.addEventListener('afterprint', function () { window.setTimeout(senden, 200); }, { once: true });
      } catch (err) { }
      try { druck.click(); } catch (err) { }
      window.setTimeout(senden, 2500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bereit);
  } else {
    bereit();
  }
  window.setTimeout(bereit, 1200);
})();